import { FC } from 'react';
import { shouldShowMerchantBranding } from '../../../services/merchantBranding';
import { getMerchantLogo } from '../../../services/utils';

interface MerchantBrandingBlockProps {
  merchant: string;
  className?: string;
}

const MerchantBrandingBlock: FC<MerchantBrandingBlockProps> = ({
  merchant,
  className,
}) => {
  if (!shouldShowMerchantBranding(merchant)) {
    return null;
  }

  const logo = getMerchantLogo(merchant);

  return (
    <div className={className}>
      {logo ? (
        <img width={85} src={logo} alt='логотип сервиса' />
      ) : (
        <h3>{merchant.toLocaleUpperCase()}</h3>
      )}
    </div>
  );
};

export default MerchantBrandingBlock;
